import { useSinglePlanBT } from "../../../../hooks";

export default function Title() {
  const {
    singlePlanBTQuery: { data, isLoading, isError, error },
  } = useSinglePlanBT();


  if (isError) {
    return <>{error.message}</>;
  }
  if (isLoading) {
    return <>Loading...</>;
  }
  return <>{data?.plan_name}</>;
}
